import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { css } from "styled-components";

// EC-753 : My List Page : Added dynamic css through code
paginationStyles.pagination = {
    selectProps: {
        labelProps: {
            css: css`
                min-height: 22px;
                display: inline-block;
                text-align: right;
                padding: 9px 15px 0px 0px;
                width: 155px;
                font-size: 15px;
                font-weight: 600;
            `,
        },
    }
}
// EC-753 : My List Page : Added dynamic css through code